import React from 'react';
import { backendApi } from '../api/backendApi';
import { useQuery } from '@tanstack/react-query';
import { Briefcase } from 'lucide-react';
import { Card, CardContent } from '../Components/ui/card';
import { Badge } from '../Components/ui/badge';

export default function PublishedJobs() {
  const { data: jobs = [] } = useQuery({
    queryKey: ['jobs'],
    queryFn: () => backendApi.entities.Job.list('-created_date', 100),
    initialData: []
  });

  const activeJobs = jobs.filter(j => j.status === 'Active');

  return (
    <div className="max-w-[1600px] mx-auto">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
        <div className="flex items-center space-x-3">
          <div className="bg-gradient-to-br from-green-500 to-green-600 p-3 rounded-lg">
            <Briefcase className="h-6 w-6 text-white" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">Published Jobs</h1>
            <p className="text-sm text-gray-500">View all active job postings</p>
          </div>
        </div>
      </div>
      
      <div className="grid gap-4">
        {activeJobs.length > 0 ? (
          activeJobs.map(job => (
            <Card key={job.id} className="shadow-sm">
              <CardContent className="p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <h3 className="font-semibold">{job.title}</h3>
                    <p className="text-sm text-gray-600">{job.client_name}</p>
                  </div>
                  <Badge className="bg-green-100 text-green-800">{job.status}</Badge>
                </div>
              </CardContent>
            </Card>
          ))
        ) : (
          <Card className="shadow-sm">
            <CardContent className="text-center py-12">
              <Briefcase className="h-12 w-12 text-gray-400 mx-auto mb-4" />
              <p className="text-gray-500">No published jobs</p>
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}